import { render, staticRenderFns } from "./ListOfAdmins.vue?vue&type=template&id=7c645a16"
import script from "./ListOfAdmins.vue?vue&type=script&lang=js"
export * from "./ListOfAdmins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports